export const icon = name => m("i", {
  className: `icon ${name}`,
  "aria-hidden": "true"
});
export const avatar = function (user, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  const source = user && typeof user.avatarUrl === 'function' ? user.avatarUrl() : null;
  const label = user && (user.displayName?.() || user.username?.()) || '?';
  const className = attrs.className || 'Avatar';
  return source ? m("img", Object.assign({}, attrs, {
    className: className,
    src: source,
    alt: label
  })) : m("span", Object.assign({}, attrs, {
    className: className,
    "aria-label": label
  }), String(label).charAt(0).toUpperCase());
};
flarum.reg.add('novatruck-theme', 'forum/components/ui', { icon: icon,avatar: avatar, });